import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { AnonymousComponent } from './anonymous/anonymous.component';
import { AuthorizedComponent } from './authorized/authorized.component';
import { LoginComponent } from './anonymous/login/login.component';
import { AppRoutingModule } from './app-routing.module';
import { ToastModule, ToastOptions } from 'ng2-toastr';
import {
  Http,
  BrowserXhr,
  RequestOptions,
  HttpModule,
  XHRBackend
} from '@angular/http';
import { AlertService } from './shared/services/alert.service';
import { BusyService } from './shared/services/busy.service';
import { httpFactory } from './shared/services/http.factory';
import { AuthService } from './shared/services/auth.service';
import { OrganizationsListComponent } from './authorized/organizations-list/organizations-list.component';
import { AdminSoundsComponent } from './authorized/admin-sounds/admin-sounds.component';
import { StatusSoundsComponent } from './authorized/status-sounds/status-sounds.component';
import { EndTimeComponent } from './authorized/end-time/end-time.component';
import { TimeRuleComponent } from './authorized/time-rule/time-rule.component';
import { VoiceRecorderComponent } from './shared/components/voice-recorder/voice-recorder.component';

import { DataTableModule, SharedModule, DialogModule, CalendarModule, ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';

import { RegionService } from './shared/services/region.service';
import { CountyService } from './shared/services/county.service';
import { StatusService } from './shared/services/status.service';
import { StateService } from './shared/services/state.service';
import { OrgCategoryService } from './shared/services/org-category.service';
import { OrganizationService } from './shared/services/organization.service';
import { HeadendService } from './shared/services/headend.service';
import { OrganizationComponent } from './authorized/organization/organization.component';
import { DistrictService } from './shared/services/district.service';
import { SCAdminToastOptions } from './shared/core/SCAdminToastOptions';
import { UserFriendlyErrorService } from './shared/services/user-friendly-error.service';
import { Auth } from './shared/core/auth';
import { AdminSoundsService } from './shared/services/admin-sounds.service';
import { SwitchStatusTimesService } from './shared/services/switch-status-times.service';
import { FileUploadService } from './shared/core/file-upload.service';
import { OrganizationStatusComponent } from './authorized/organization-status/organization-status.component';
import { SimplePlayerComponent } from './shared/components/simple-player/simple-player.component';
import { StatusComponent } from './authorized/status/status.component';
import { StatusEndTimeRulesService } from './shared/services/status-end-time-rules.service';
import { Router } from '@angular/router';
import { PaginatorModule } from 'primeng/components/paginator/paginator';

@NgModule({
  declarations: [
    AppComponent,
    AnonymousComponent,
    AuthorizedComponent,
    LoginComponent,
    OrganizationsListComponent,
    AdminSoundsComponent,
    StatusSoundsComponent,
    EndTimeComponent,
    TimeRuleComponent,
    OrganizationComponent,
    VoiceRecorderComponent,
    OrganizationStatusComponent,
    SimplePlayerComponent,
    StatusComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    ToastModule.forRoot(),
    HttpModule,
    DataTableModule,
    SharedModule,
    DialogModule,
    ReactiveFormsModule,
    CalendarModule,
    ConfirmDialogModule,
    PaginatorModule,
  ],
  providers: [
    {
      provide: Http,
      useFactory: httpFactory,
      deps: [
        XHRBackend,
        RequestOptions,
        AlertService,
        BusyService,
        UserFriendlyErrorService,
        Router
      ]
    },
    AlertService,
    BusyService,
    AuthService,
    XHRBackend,
    BrowserXhr,
    RegionService,
    StatusService,
    OrgCategoryService,
    OrganizationService,
    HeadendService,
    StateService,
    CountyService,
    DistrictService,
    AdminSoundsService,
    SwitchStatusTimesService,
    FileUploadService,
    Auth,
    { provide: ToastOptions, useClass: SCAdminToastOptions },
    UserFriendlyErrorService,
    ConfirmationService,
    StatusEndTimeRulesService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/app.module.ts